import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('taxonomy', 'name')
}

const getters = {
  ...gettersMixin()
}

const mutations = {
  ...mutationsMixin()
}

const actions = {
  ...actionsMixin({ include: ['children', 'parent', 'products'] })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
